import { render, staticRenderFns } from "./factoryUser.vue?vue&type=template&id=8a47907a&scoped=true&"
import script from "./factoryUser.vue?vue&type=script&lang=js&"
export * from "./factoryUser.vue?vue&type=script&lang=js&"
import style0 from "./factoryUser.vue?vue&type=style&index=0&id=8a47907a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a47907a",
  null
  
)

export default component.exports